import OrgLogoView from "@components/common/OrgLogoView";

import { Box, Flex, Grid, Stack, Text } from "@mantine/core";
import { getOrganizationById } from "@utils/api-communication/RestApiCli";
import React, { useEffect, useState } from "react";
import { Organization } from "types/accountManagementTypes";

interface OrganizationDetailViewProps {
  organization: Organization | null;
  organizationId?: string;
  compact?: boolean;
}

const OrganizationDetailView: React.FC<OrganizationDetailViewProps> = ({
  organization,
  organizationId,
  compact = false,
}) => {
  const [org, setOrg] = useState<Organization | null>(null);

  useEffect(() => {
    if (!organizationId || organization) return;
    getOrganizationById(
      organizationId,
      (response) => {
        setOrg(response.data);
      },
      (error) => {
        console.error("Failed to fetch organization:", error);
      },
    );
  }, [organizationId, organization]);

  if (compact) {
    return (
      <Flex align="center" gap="md" wrap="nowrap">
        <Box w={100} h={100} style={{ flexShrink: 0 }}>
          <OrgLogoView
            organization={org}
            isEditMode={false}
            imageSize={{ width: 100, height: 100 }}
          />
        </Box>
        <Stack gap={4}>
          <Text fw={700} fz="lg" style={{ whiteSpace: "nowrap" }}>
            {org?.name}
          </Text>
          <Text color="dimmed" style={{ whiteSpace: "nowrap" }}>
            {org?.address}
          </Text>
        </Stack>
      </Flex>
    );
  }

  return (
    <Box style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
      <Grid style={{ width: "auto" }}>
        <Grid.Col span="auto">
          <OrgLogoView
            organization={org}
            isEditMode={false}
            imageSize={{ width: 80, height: 80 }}
          />
        </Grid.Col>
        <Grid.Col span="auto">
          <Stack gap={4}>
            <Text fw={700} fz="lg" style={{ whiteSpace: "nowrap" }}>
              {org?.name}
            </Text>
            <Text color="dimmed">{org?.address}</Text>
          </Stack>
        </Grid.Col>
      </Grid>
    </Box>
  );
};
export default OrganizationDetailView;
